"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PreviewCode = _interopRequireDefault(require("../PreviewCode/PreviewCode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PreviewJSON = ({
  theme = "light",
  data
}) => {
  return _react.default.createElement(_PreviewCode.default, {
    theme: theme,
    language: "json"
  }, data);
};

var _default = PreviewJSON;
exports.default = _default;
module.exports = exports.default;